import React from 'react';
import { useGetVisalbyIdQuery } from '../../../store/api/contact';

function DetailModal({ onclose, isopen, medicalinfoId }) {
  // Fetch the data using RTK Query hook
  const { data, isLoading, isError } = useGetVisalbyIdQuery(medicalinfoId, {
    skip: !medicalinfoId, // Skip query if no ID
  });

  if (!isopen) return null;

  const BASE_URL = process.env.REACT_APP_API_URL?.replace('/api', '');

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6 relative overflow-y-auto max-h-[90vh]">
        {/* Close button */}
        <button
          onClick={onclose}
          className="absolute top-2 right-3 text-gray-500 hover:text-gray-800 text-lg"
        >
          ✕
        </button>

        <h2 className="text-xl font-semibold mb-4 text-gray-800">Visa Details</h2>

        {isLoading && <p className="text-gray-500">Loading...</p>}
        {isError && <p className="text-red-500">Failed to load data.</p>}

        {data && (
          <div className="space-y-2 text-sm text-gray-700">
            <p><strong>Name:</strong> {data.full_name}</p>
            <p><strong>Phone Number:</strong> {data.phone_number}</p>
            <p><strong>Address:</strong> {data.address}</p>
            <p><strong>Age:</strong> {data.age}</p>
            <p><strong>Gender:</strong> {data.gender}</p>
            <p><strong>Visa Type:</strong> {data.visa_type}</p>
            <p><strong>Travel Alone:</strong> {data.travel_alone}</p>
            <p><strong>Reason for Travel:</strong> {data.reason_for_travel}</p>
            <p><strong>Past Visa Rejections:</strong> {data.past_visa_rejections}</p>
            <p>
              <strong>Fast Track Services:</strong>{' '}
              {data.fast_track_services ? 'Yes' : 'No'}
            </p>
            <p>
              <strong>Travel Start Date:</strong>{' '}
              {new Date(data.travel_start_date).toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })}
            </p>
            <p>
              <strong>Travel End Date:</strong>{' '}
              {new Date(data.travel_end_date).toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })}
            </p>
            <p>
              <strong>Created At:</strong>{' '}
              {new Date(data.created_at).toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default DetailModal;
